// extracted by mini-css-extract-plugin
export default {"customField":"CustomExtendedDataField_customField__qwZyL","inputError":"CustomExtendedDataField_inputError__2STvC"};